import { getFirebaseDb } from "./firebase-ultra-safe";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  serverTimestamp,
  doc,
  getDoc,
} from "firebase/firestore";

// 채팅 메시지 읽음 처리
export async function markAllMessagesAsRead(
  chatId: string,
  userId: string
): Promise<{ success: boolean; error?: string }> {
  const db = await getFirebaseDb();
  if (!db) {
    return { success: false, error: "Firebase DB 초기화 실패" };
  }

  try {
    console.log("채팅의 모든 메시지 읽음 처리:", chatId, userId);

    // 채팅의 모든 메시지 조회
    const messagesRef = collection(db, "chats", chatId, "messages");
    const q = query(
      messagesRef,
      where("isRead", "==", false),
      where("receiverId", "==", userId)
    );

    const snapshot = await getDocs(q);

    if (snapshot.docs.length === 0) {
      return { success: true };
    }

    // 배치 업데이트
    const updatePromises = snapshot.docs.map(doc => {
      return updateDoc(doc.ref, {
        isRead: true,
        readAt: serverTimestamp(),
      });
    });

    await Promise.all(updatePromises);

    console.log("채팅 메시지 읽음 처리 완료:", snapshot.docs.length, "개");
    return { success: true };
  } catch (error) {
    console.error("채팅 메시지 읽음 처리 실패:", error);
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "채팅 메시지 읽음 처리에 실패했습니다.",
    };
  }
}

// 특정 메시지 읽음 처리
export async function markMessageAsRead(
  chatId: string,
  messageId: string,
  userId: string
): Promise<{ success: boolean; error?: string }> {
  const db = await getFirebaseDb();
  if (!db) {
    return { success: false, error: "Firebase DB 초기화 실패" };
  }

  try {
    console.log("메시지 읽음 처리:", messageId, userId);

    const messageRef = doc(db, "chats", chatId, "messages", messageId);
    const messageSnap = await getDoc(messageRef);

    if (!messageSnap.exists()) {
      return { success: false, error: "메시지를 찾을 수 없습니다." };
    }

    const messageData = messageSnap.data();

    // 권한 확인 (받는 사람만 읽음 처리 가능)
    if (messageData.receiverId !== userId) {
      return { success: false, error: "권한이 없습니다." };
    }

    // 이미 읽음 처리된 경우
    if (messageData.isRead) {
      return { success: true };
    }

    // 읽음 처리
    await updateDoc(messageRef, {
      isRead: true,
      readAt: serverTimestamp(),
    });

    console.log("메시지 읽음 처리 완료:", messageId);
    return { success: true };
  } catch (error) {
    console.error("메시지 읽음 처리 실패:", error);
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "메시지 읽음 처리에 실패했습니다.",
    };
  }
}

// 채팅의 읽지 않은 메시지 개수 조회
export async function getUnreadMessageCount(
  chatId: string,
  userId: string
): Promise<{ success: boolean; count?: number; error?: string }> {
  const db = await getFirebaseDb();
  if (!db) {
    return { success: false, error: "Firebase DB 초기화 실패" };
  }

  try {
    console.log("읽지 않은 메시지 개수 조회:", chatId, userId);

    const messagesRef = collection(db, "chats", chatId, "messages");
    const q = query(
      messagesRef,
      where("isRead", "==", false),
      where("receiverId", "==", userId)
    );

    const snapshot = await getDocs(q);
    const count = snapshot.docs.length;

    console.log("읽지 않은 메시지 개수:", count);
    return { success: true, count };
  } catch (error) {
    console.error("읽지 않은 메시지 개수 조회 실패:", error);
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "읽지 않은 메시지 개수를 조회하는데 실패했습니다.",
    };
  }
}
